__turbopack_context__.v({
  "checkIcon": "Professional-module-scss-module__dnmqYW__checkIcon",
  "description": "Professional-module-scss-module__dnmqYW__description",
  "descriptionItem": "Professional-module-scss-module__dnmqYW__descriptionItem",
  "inner": "Professional-module-scss-module__dnmqYW__inner",
  "logoContainer": "Professional-module-scss-module__dnmqYW__logoContainer",
  "professional": "Professional-module-scss-module__dnmqYW__professional",
  "professionalCard": "Professional-module-scss-module__dnmqYW__professionalCard",
  "professionalCards": "Professional-module-scss-module__dnmqYW__professionalCards",
  "professionalContent": "Professional-module-scss-module__dnmqYW__professionalContent",
  "professionalLabel": "Professional-module-scss-module__dnmqYW__professionalLabel",
  "wrap": "Professional-module-scss-module__dnmqYW__wrap",
});
